import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import SparePartProductViewObject = Vertica.LouisPoulsen.Application.Content.Pages.CategoryPage.SparePartProductViewObject;
import { QueryParams } from '@/core';
import { TabEnum } from '@/ui/shared/Tabs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SparePartTile',
  props: {
    sparePart: null,
    isPrivateMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {sparePart: SparePartProductViewObject, isPrivateMode?: boolean }


const showErrorImage = ref<boolean>(false);

function imageSuccess() {
    showErrorImage.value = false;
}

function imageError() {
    showErrorImage.value = true;
}

const linkToSparepartTab = computed<string>(() => {
    let appendQuery: string = '?';
    appendQuery += QueryParams.SelectedTab + '=' + TabEnum.Spareparts;
    appendQuery += '&';
    appendQuery += QueryParams.ScrollToId + '=' + 'spareparts';
    return props.sparePart.linkUrl + appendQuery;
});


return { __sfc: true,props, showErrorImage, imageSuccess, imageError, linkToSparepartTab }
}

})